import CookieManager from "./localstorage/CookieManager";
import { navigateToLandingPage } from "./NavigationHelper";
import { setRecentViewBackets } from "utilities/js/localstorage/StorageHelper_ViewBrackets";
import { setRecentCreateBackets } from "utilities/js/localstorage/StorageHelper_CreateBrackets";
import Constants from "./Constants";

export function logout(){
    const cookieManager = new CookieManager();
    cookieManager.clearAllValues();
    setRecentCreateBackets(null);
    setRecentViewBackets(null);
    navigateToLandingPage();
}

export function isLoggedIn(){
    const cookieManager = new CookieManager();
    return !!cookieManager.getValue(Constants.COOKIE_USER_EMAIL_KEY)
}